import api from '@/api/api';

const state = {
    testSuiteNames: [],
};

const getters = {
    testSuiteNames: state => state.testSuiteNames,
};

const mutations = {
    SET_TEST_SUITE_NAMES(state, testSuiteNames) {
        state.testSuiteNames = testSuiteNames;
    },
};

const actions = {
    /**
     * Fetch all test suites and save it to state.
     * @return {Promise} result.
     */
    async fetchTestSuiteNames({ commit, getters }) {
        if (getters.testSuiteNames.length > 0) return;
        try {
            const { test_suite_names } = await api.testResults.fetchTestSuiteNames();
            commit('SET_TEST_SUITE_NAMES', test_suite_names);
        } catch (error) {
            return Promise.reject('Error of test suites list fetching');
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
